/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Txn } from '@src/app/model/txn';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { FieldSet } from '@src/app/shared/form/field-set/field-set.component';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { BCodeService } from '@src/app/modules/budget/bcode.service';
import { ArTxnService } from '@src/app/modules/txn/ar-txn.service';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { ArPageNavRoute } from '@src/app/routes/ar-page-nav';
import { InvoicePageNavRoute } from '@src/app/routes/invoice-page-nav';
import { CreditNotePageNavRoute } from '@src/app/routes/credit-note-page.nav';

@Component({
    selector: 'app-ar-page',
    templateUrl: './ar-page.component.html',
    styleUrls: ['./ar-page.component.scss'],
    imports: [FormPageComponent]
})
export class ArPageComponent extends AbstractPageComponent {
    dataSvc = inject(ArTxnService);
    bCodeSvc = inject(BCodeService);
    protected activeRoute = inject(ActivatedRoute);


    readonly path = Txn.LEDGER.AR.code;

    config = new FormConfig({
        navRoute: ArPageNavRoute,
        title: Txn.LEDGER.AR.name,
        help: $localize`Financial transactions`,
        fieldSet: new FieldSet({
            fields: this.dataSvc.getFields(),
            formLayout: [
                { cells: [{ width: '25%' }, { width: '25%' }, { width: '25%' }, { width: '25%' }] },
                { cells: [{ colspan: 4, pageTab: 'yes' }] }
            ],
        }),
        service: this.dataSvc,
        mode: 'list',
        objectFactory: () => of(new Txn()), // this.newFactory.bind(this),
        newOptions: [
            { name: $localize`New ${Txn.TYPE.INVOICE.name}`, basePath: InvoicePageNavRoute.newUrl, params: {}, id: 'newInvoice' },
            { name: $localize`New ${Txn.TYPE.CREDIT_NOTE.name}`, basePath: CreditNotePageNavRoute.newUrl, params: {}, id: 'newCreditNote' }
        ],
        pathEdit: (o: Txn) => Txn.getTxnLink(o)
    });

    newFactory(): Observable<Txn> {
        const txn = new Txn();
        txn.typeId = +this.activeRoute.snapshot.queryParamMap.get('typeId');
        console.warn(txn, this.activeRoute.snapshot);
        return of(txn);
    }

}
